import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { drawLayoutStroke } from '@/common/preview/draw-layout-stroke';

export const initStrokeSettings = () => {
    const getScopePage = () => ShowPageScopeCollector.get(['previews']);
    const { previews } = getScopePage();
    
    // Initialize existing stroke settings
    initializeStrokeSettings(previews);

    $(document).on('click', '.stroke-color', function (e) {
        e.preventDefault();
        const instanceId = $(this).data('id');

        if (!$('#strokeSettingsModal').length) {
            $('body').append(`
            <div class="modal fade" id="strokeSettingsModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Stroke Settings</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                    <label>Color</label>
                    <input type="color" class="form-control" id="stroke_color" value="#6d6d6d">
                    </div>
                    <div class="form-group">
                    <label>Width</label>
                    <input type="number" class="form-control" id="stroke_width" min="0" max="20" value="1" step="1">
                    <small class="form-text text-muted">Width in pixels</small>
                    </div>
                    <div class="form-group">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="show_template_stroke" checked>
                        <label class="custom-control-label" for="show_template_stroke">Show Stroke</label>
                    </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" id="applyStrokeSettings">Apply</button>
                </div>
                </div>
            </div>
            </div>
        `);
        }

        // Remove existing event handlers and reattach
        $('#stroke_width').off('input').on('input', function () {
            $('#stroke_width_value').text($(this).val());
        });

        $(document).off('click', '#applyStrokeSettings').on('click', '#applyStrokeSettings', function () {
            const getScopePage = () => ShowPageScopeCollector.get(['drawPreviews', 'rerenderTemplates', 'previews', 'updateLayoutChanges', 'layout_options']);
            const { previews, updateLayoutChanges, layout_options } = getScopePage();
            const modalInstanceId = $('#strokeSettingsModal').data('instanceId');
            const preview = previews.find(p => p.id === modalInstanceId);
            const { id, canvas, dimension, data, template, shadows, themes } = preview;

            // Get the canvas elements
            const canvasElement = $(`#canvas-${modalInstanceId}`)[0];
            if (!canvasElement) {
                return;
            }

            // Get the Fabric.js canvas instance from the canvas element
            if (!canvas) {
                return;
            }

            const color = $('#stroke_color').val();
            const width = parseInt($('#stroke_width').val());
            const showStroke = $('#show_template_stroke').prop('checked');

            // Remove existing stroke objects
            canvas.getObjects().forEach(function (o) {
                if (o.id === 'layout_stroke' || o.id === 'stroke') {
                    canvas.remove(o);
                }
                if(!showStroke){
                    if (layout_options && layout_options.show_stroke) {
                        const layoutOptionsParam = {
                          layout_options,
                          width: canvas.getWidth(),
                          height: canvas.getHeight(),
                          canvas
                        };
                        drawLayoutStroke(layoutOptionsParam);
                      }
                }
            });

            if (showStroke) {
                const rect = new fabric.Rect({
                    id: 'stroke',
                    top: 0,
                    left: 0,
                    width: canvas.getWidth() - width,
                    height: canvas.getHeight() - width,
                    fill: 'transparent',
                    stroke: color,
                    strokeWidth: width,
                    selectable: false,
                    evented: false,
                });

                canvas.add(rect);
                canvas.bringToFront(rect);
            }

            canvas.renderAll();
            $('#strokeSettingsModal').modal('hide');

            updateLayoutChanges(id, 'stroke_template_settings', {
                stroke_color: color,
                stroke_width: width,
                show_stroke: showStroke,
            });
        });

        $('#strokeSettingsModal').data('instanceId', instanceId).modal('show');
    });
}

export const initializeStrokeSettings = (previews) => {
    if (!previews || !previews.length) return;
    
    previews.forEach(preview => {
        const { id, canvas, data } = preview;
        if (!canvas || !data) return;

        const strokeSettings = data.stroke_template_settings;
        if (!strokeSettings) return;

        const { stroke_color, stroke_width, show_stroke } = strokeSettings;

        // Remove any existing stroke objects
        canvas.getObjects().forEach(function (o) {
            if (o.id === 'stroke') {
                canvas.remove(o);
            }
        });

        if (show_stroke) {
            const rect = new fabric.Rect({
                id: 'stroke',
                top: 0,
                left: 0,
                width: canvas.getWidth() - stroke_width,
                height: canvas.getHeight() - stroke_width,
                fill: 'transparent',
                stroke: stroke_color || '#6d6d6d',
                strokeWidth: stroke_width || 1,
                selectable: false,
                evented: false,
            });

            canvas.add(rect);
            canvas.bringToFront(rect);
            canvas.renderAll();
        }
    });
};